<template>

    <div class="np-nav-item dropdown language-switcher" v-if="switcherStyle == 'dropdown'">
        <div class="np-btn np-nav-link" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <img :src="require('@/assets/images/dashboard/' + currentLanguage + '.png')" />
        </div>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
            <li class="dropdown-item"><a class="btn btn-sm" @click="changeLanguage('en')"><img src="@/assets/images/dashboard/en.png" /> English</a></li>
            <li class="dropdown-item"><a class="btn btn-sm" @click="changeLanguage('ru')"><img src="@/assets/images/dashboard/ru.png" /> Русский</a></li>
            <li class="dropdown-item"><a class="btn btn-sm" @click="changeLanguage('de')"><img src="@/assets/images/dashboard/de.png" /> Deutsch</a></li>
            <li class="dropdown-item"><a class="btn btn-sm" @click="changeLanguage('es')"><img src="@/assets/images/dashboard/es.png" /> Español</a></li>
            <li class="dropdown-item"><a class="btn btn-sm" @click="changeLanguage('fr')"><img src="@/assets/images/dashboard/fr.png" /> Français</a></li>
            <li class="dropdown-item"><a class="btn btn-sm" @click="changeLanguage('it')"><img src="@/assets/images/dashboard/it.png" /> Italiano</a></li>
            <li class="dropdown-item"><a class="btn btn-sm" @click="changeLanguage('pl')"><img src="@/assets/images/dashboard/pl.png" /> Polski</a></li>
            <li class="dropdown-item"><a class="btn btn-sm" @click="changeLanguage('pt')"><img src="@/assets/images/dashboard/pt.png" /> Português</a></li>
            <li class="dropdown-item"><a class="btn btn-sm" @click="changeLanguage('tr')"><img src="@/assets/images/dashboard/tr.png" /> Türkçe</a></li>
            <li class="dropdown-item"><a class="btn btn-sm" @click="changeLanguage('ko')"><img src="@/assets/images/dashboard/ko.png" /> 한국어</a></li>
        </ul>                
    </div>

    <div class="text-center language-switcher m-2"  v-if="switcherStyle == 'inline'">
        <button class="btn btn-sm" @click="changeLanguage('en')" style="transform: scale(0.8);">
            <img src="@/assets/images/dashboard/en.png" />
        </button>
        <button class="btn btn-sm" @click="changeLanguage('ru')" style="transform: scale(0.8);">
            <img src="@/assets/images/dashboard/ru.png" />
        </button>
        <button class="btn btn-sm" @click="changeLanguage('de')" style="transform: scale(0.8);">
            <img src="@/assets/images/dashboard/de.png" />
        </button>        
        <button class="btn btn-sm" @click="changeLanguage('es')" style="transform: scale(0.8);">
            <img src="@/assets/images/dashboard/es.png" />
        </button>        
        <button class="btn btn-sm" @click="changeLanguage('fr')" style="transform: scale(0.8);">
            <img src="@/assets/images/dashboard/fr.png" />
        </button>        
        <button class="btn btn-sm" @click="changeLanguage('it')" style="transform: scale(0.8);">
            <img src="@/assets/images/dashboard/it.png" />
        </button>        
        <button class="btn btn-sm" @click="changeLanguage('pl')" style="transform: scale(0.8);">
            <img src="@/assets/images/dashboard/pl.png" />
        </button>        
        <button class="btn btn-sm" @click="changeLanguage('pt')" style="transform: scale(0.8);">
            <img src="@/assets/images/dashboard/pt.png" />
        </button>        
        <button class="btn btn-sm" @click="changeLanguage('tr')" style="transform: scale(0.8);">
            <img src="@/assets/images/dashboard/tr.png" />
        </button>        
        <button class="btn btn-sm" @click="changeLanguage('ko')" style="transform: scale(0.8);">
            <img src="@/assets/images/dashboard/ko.png" />
        </button>                                                                
    </div>
  </template>
  
<script>
import { useI18n } from 'vue-i18n';
import { ref, watch } from 'vue';

export default {
    props: {
        switcherStyle: {
            type: String,
            default: "inline"
        }
    },
    setup(props) {
        const { locale } = useI18n()
        const currentLanguage = ref(locale.value)

        watch(locale, (newLocale) => {
            currentLanguage.value = newLocale;
        })

        const changeLanguage = (lang) => {
            locale.value = lang;
            localStorage.setItem('lang', lang)
        }

        return {
            changeLanguage,
            currentLanguage,
            switcherStyle: props.switcherStyle
        }
    }
}

</script>
<style>
    .language-switcher img {
        width: 24px;
    }
</style>